import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import gtag from "ga-gtag";
import React, { useEffect, useState } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import "./App.css";
import Newsdetails from "./components/pages/newsdetails";
import SinglePage from "./components/pages/SinglePage";
import ModalComponent from "./components/popmodel/ModalComponent";
import configData from "../src/config.json";
import enquireLogo from "../src/assets/imgs/festival.png";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isApiChecked, setIsApiChecked] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleWhatappGtag = () => {
    gtag("event", "FloatWhatsapp", {
      section_name: "WhatsappFloat",
    });
  };

  const getUTMParams = async () => {
    const urlParams = await new URLSearchParams(window.location.search);

    const utmData = {
      utm_source: (await urlParams.get("utm_source")) || "website",
      utm_campaign: (await urlParams.get("utm_campaign")) || "website",
      utm_medium: (await urlParams.get("utm_medium")) || "website",
    };
    sessionStorage.setItem("utm_data", JSON.stringify(utmData));
  };

  const callapi = async () => {
    try {
      let res = await axios.get(`${configData.API_URL}page`);
      const allPages = await res.data.data;
      const currentPath = window.location.pathname.split("/")[1];
      const matchingInactive = await allPages.find(
        (item) => item.status === "INACTIVE" && item.sku === currentPath,
      );

      const nonMatchingSkus =
        currentPath !== "" &&
        !allPages.some(
          (item) => item.sku !== "page_not_found" && item.sku === currentPath,
        );

      if (matchingInactive || nonMatchingSkus) {
        navigate("/page_not_found");
      }

      setIsApiChecked(true);
    } catch (err) {
      console.error("Error fetching data:", err);
      setIsApiChecked(true);
    }
  };

  useEffect(() => {
    getUTMParams();
    const handlePageHide = (event) => {
      if (!event.persisted) {
        sessionStorage.removeItem("utm_data");
      }
    };

    window.addEventListener("pagehide", handlePageHide);
    return () => {
      window.removeEventListener("pagehide", handlePageHide);
    };
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      const isModalShown = sessionStorage.getItem("isModalShown");
      if (!isModalShown) {
        setIsModalOpen(true);
        sessionStorage.setItem("isModalShown", "true");
      }
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    callapi();
  }, [location.pathname]);

  return (
    <>
      {isApiChecked && (
        <Routes>
          <Route path="/news/:newsurl" element={<Newsdetails />} />
          <Route path="*" element={<SinglePage />} />
        </Routes>
      )}

      {location.pathname !== "/enquire-now" && (
        <a
          href="https://bydautoindia.com/enquire-now"
          className="floating_button enquireLogobox"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={enquireLogo} className="enquireLogo whatsapp_float" />
        </a>
      )}
      {location.pathname !== "/enquire-now" && (
        <a
          href="https://wa.me/917303950845?text=hello"
          className="whatsapp_float"
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleWhatappGtag}
        >
          <div className="whatsapp_icon_wrapper">
            <FontAwesomeIcon icon={faWhatsapp} className="whatsapp-icon" />
          </div>
        </a>
      )}
      <ModalComponent isOpen={isModalOpen} onClose={handleCloseModal} />
      <ToastContainer
        position="bottom-right"
        autoClose={6000}
        toastClassName="my-custom-toast"
      />
    </>
  );
}
export default App;
